import ContractorsListEnhanced from '../components/ContractorsListEnhanced';

export const Contractors = () => {
  return <ContractorsListEnhanced />;
};